"use client"
import { useState } from "react"
import { AnimatePresence, motion } from "framer-motion"
import { useLanguage } from "../context/LanguageContext"
import heroBg from "../assets/images/hero-section-bg.svg"
import heroBgPhone from "../assets/images/hero-section-bg-phone.svg"
import advanceSalary from "../assets/images/hero-section-img.svg"
import advanceSalaryPhone from "../assets/images/hero-section-img-phone.svg"
import advanceSalaryAr from "../assets/images/hero-section-bg-ar.svg"
import { fadeIn, fadeUp, slideLeft, staggerContainer } from "../lib/motion"
import GetInTouchModal from "./GetInTouchModal"

export function HeroSection() {
  const { translation: t, isRTL, lang } = useLanguage()
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <AnimatePresence>
        {isModalOpen && <GetInTouchModal setIsModalOpen={setIsModalOpen} variant="bookDemo" />}
      </AnimatePresence>
      <motion.section
        className="relative hero-reveal"
        dir={isRTL ? "rtl" : "ltr"}
        variants={fadeIn}
        initial="hidden"
        animate="show"
        >
        <img
          src={heroBg}
          alt="hero background"
          className="hidden lg:block w-full h-auto absolute top-0 left-0"
          style={{ transform: isRTL ? "scaleX(-1)" : "scaleX(1)" }}
          />
        <img
          src={heroBgPhone}
          alt="hero background"
          className="lg:hidden w-full h-auto absolute top-0 left-0"
          style={{ transform: isRTL ? "scaleX(-1)" : "scaleX(1)" }}
          />
        <motion.div
          className="relative inset-0 px-0 md:px-6 lg:px-10 flex flex-col-reverse lg:flex-row items-center lg:items-start justify-between pt-0 md:pt-12 lg:pt-20 xl:my-10 text-center lg:text-start my-5 md:my-0"
          variants={staggerContainer(0.12, 0.1)}
          initial="hidden"
          animate="show"
        >
          <motion.div
            className="relative z-10 w-full md:w-[50%] lg:w-[40%] xl:w-[32%] mt-8 md:mt-12 lg:mt-14 xl:mt-20 px-5 md:px-0 flex flex-col items-center lg:items-start gap-6 lg:gap-8 xl:gap-[2.625rem] hover-sweep hero-hover-zone"
            variants={fadeUp}
          >
            <motion.h1 className="xl:w-[103%] text-[2rem] md:text-4xl lg:text-[2.5rem] font-bold text-primary !leading-tight hero-title" variants={fadeUp}>
              {t.heroTitle}
            </motion.h1>
            <motion.p className="text-primary text-lg xl:text-2xl leading-[140%] lg:!leading-9 hero-text hero-desc" variants={fadeUp}>
              {t.heroDesc}
            </motion.p>
            <motion.button
              className={`h-11 lg:h-[3.625rem] inline-flex items-center justify-center w-full bg-softGreen text-white py-0 rounded-full font-semibold leading-normal hover:bg-[#66B57C] transition-colors text-lg md:text-xl lg:text-[1.375rem] hover-glow ${lang === "ar" ? "font-arabic" : ""}`}
              variants={fadeUp}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              onClick={() => setIsModalOpen(true)}
            >
              {t.bookDemo}
            </motion.button>
          </motion.div>
          <motion.div
            className={`relative z-40 ${isRTL ? 'lg:-left-16 xl:-left-28' : 'lg:-right-16 xl:-right-28'} lg:-mt-12 flex justify-center items-center flex-1 w-full md:w-3/4 lg:w-1/2 hero-hover-zone`}
            variants={slideLeft}
          >
            <div className="hidden lg:block relative w-full h-full z-40 hero-image-wrap hero-asset">
              <motion.img
                src={isRTL ? advanceSalaryAr : advanceSalary}
                alt="NowPay Salary Advance"
                className="w-full h-full object-contain lg:mt-10 xl:mt-0 scale-[0.8] md:scale-90 lg:scale-x-[1.1] xl:scale-[0.96] relative z-40 hero-image animate-float"
                initial={{ opacity: 0, y: 32 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7, ease: "easeOut", delay: 0.15 }}
              />
            </div>
            <div
              className="relative lg:hidden w-[90%] md:w-full h-full z-40 hero-image-wrap hero-asset"
              style={{ transform: isRTL ? "scaleX(-1)" : "scaleX(1)" }}
            >
              <motion.img
                src={advanceSalaryPhone}
                alt="NowPay Salary Advance"
                className="w-full h-full mt-8 object-contain scale-[0.8] md:scale-90 lg:scale-[0.96] relative z-40 hero-image animate-float"
                initial={{ opacity: 0, y: 32 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7, ease: "easeOut", delay: 0.15 }}
              />
            </div>
          </motion.div>
        </motion.div>
      </motion.section>
    </>
  )
}
